<ng-container *ngIf="!isLoading">

  <!-- Buttons -->
  <div style="text-align:center; margin-bottom:10px">
    <button class="noPrint" mat-raised-button color="primary" (click)="printPage()">
      Print
    </button>

    <button class="noPrint" style="margin-left:10px" (click)="exportExcel('Representativewise_Sadhyasthiti_Report')" mat-raised-button color="primary">
      Export
    </button>

    <button mat-dialog-close class="btn noPrint" style="margin-left:10px">
      Close
    </button>
  </div>


  <!-- PRINT SECTION -->
  <div id="print-section">

    <table style=" table-layout: fixed !important; font-size:14px;">

      <!-- MAIN HEADER -->
      <thead>

        <tr>
          <th colspan="8"
              style="border:2px solid black; text-align:center; font-size:18px; padding:6px;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
          </th>
        </tr>

        <tr>
          <th colspan="8" style="border-left:2px solid black; border-right:2px solid black; border-bottom:2px solid black; text-align:right; padding:4px;">
            दिनांक :- {{ endDate | date:"dd/MM/yyyy" }}
          </th>
        </tr>

        <tr>
          <th colspan="8" style="border:2px solid black; text-align:center; font-size:16px; padding:6px;">
           जिल्हा प्रतिनिधीनिहाय सद्यस्थिती
          </th>
        </tr>

        <!-- COLUMN HEADER -->
        <tr style="border:2px solid black;">
          <th style="border:1px solid black; ">अनुक्रमांक</th>
          <th style="border:1px solid black; ">जिल्हा</th>
          <th style="border:1px solid black; ">प्रतिनिधी निहाय</th>
          <th style="border:1px solid black; ">पोस्ट</th>
          <th style="border:1px solid black; ">हस्ते</th>
          <th style="border:1px solid black; ">मॅगझीन</th>
          <th style="border:1px solid black; ">डिजिटल</th>
          <th style="border:1px solid black; ">एकूण</th>
        </tr>

      </thead>


      <!-- BODY -->
   <!-- <tbody>

  
  <ng-container *ngFor="let district of representativeData; let dIndex = index">

   
    <tr class="br_tp_bt">
      <td colspan="8"
          style="border-left:2px solid black; border-right:2px solid black; border-top:2px solid black; border-bottom:2px solid black; font-weight:bold;">
        जिल्हा : {{ district.rep_district }}
      </td>
    </tr>


   
    <ng-container *ngFor="let prant of district.prants">

  
      <tr>
        <td style="border-left:2px solid black;"></td>
        <td colspan="7" style="font-weight:bold;">
          प्रांत : {{ prant.prant }}
        </td>
      </tr>


    
      <tr *ngFor="let rep of prant.representatives; let i=index">

        <td style="border-left:2px solid black; text-align:center;">
          {{ i + 1 }}
        </td>

        <td>
          {{ district.rep_district }}
        </td>

        <td>
          {{ rep.repName }} - {{ rep.rep_taluka }}
        </td>

        <td style="text-align:right;">
          {{ rep.post }}
        </td>

        <td style="text-align:right;">
          {{ rep.haste }}
        </td>

        <td style="text-align:right;">
          {{ rep.magazine }}
        </td>

        <td style="text-align:right;">
          {{ rep.digital }}
        </td>

        <td style="border-right:2px solid black; text-align:right;">
          {{ rep.total }}
        </td>

      </tr>

    </ng-container>


    <tr class="fontBold">

      <td colspan="3"
          style="border-left:2px solid black; border-top:2px solid black; border-bottom:2px solid black; text-align:center; font-weight:bold;">
        {{ district.rep_district }} - एकूण
      </td>

      <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right;">
        {{ district.districtPost }}
      </td>

      <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right;">
        {{ district.districtHaste }}
      </td>

      <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right;">
        {{ district.districtMagazine }}
      </td>

      <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right;">
        {{ district.districtDigital }}
      </td>

      <td style="border-right:2px solid black; border-top:2px solid black; border-bottom:2px solid black; text-align:right;">
        {{ district.districtTotal }}
      </td>

    </tr>

  </ng-container>


 
  <tr class="fontBold br_tp_bt">

    <td colspan="3"
        style="border-left:2px solid black; text-align:center;">
      एकूण
    </td>

    <td style="text-align:right;">
      {{ totalPostTotal }}
    </td>

    <td style="text-align:right;">
      {{ totalHasteTotal }}
    </td>

    <td style="text-align:right;">
      {{ totalMagzineTotal }}
    </td>

    <td style="text-align:right;">
      {{ totalDigitalTotal }}
    </td>

    <td style="border-right:2px solid black; text-align:right;">
      {{ grandTotal }}
    </td>

  </tr>

</tbody> -->

<tbody>

  <!-- ================= PRANT LOOP ================= -->
  <ng-container *ngFor="let prant of representativeData">

    <!-- 🔹 PRANT HEADER -->
    <tr class="br_tp_bt">
      <td colspan="8"
          style="border:2px solid black; font-weight:bold;">
        {{ prant.prant }}
      </td>
    </tr>


    <!-- ================= DISTRICT LOOP ================= -->
    <ng-container *ngFor="let district of prant.districts; let i1 = index">

      <!-- 🔹 DISTRICT HEADER (ONLY PLACE WHERE DISTRICT SHOWS) -->
      <tr>
        <td  colspan="1" style="border-left:2px solid black; font-weight: bold;">{{ i1 + 1 }}</td>
        <td colspan="1" style="font-weight: bold;">
          {{ district.rep_district }}
        </td>
        <td  colspan="6" style="border-left:2px solid black;"></td>
      </tr>


      <!-- ================= REPRESENTATIVE LOOP ================= -->
      <tr *ngFor="let rep of district.representatives; let i = index">

        <!-- Serial No -->
        <td style="border-left:2px solid black; text-align:center;">
          <!-- {{ i + 1 }} -->
        </td>

        <td colspan="1"></td>

        <!-- ❌ District column removed -->
        <!-- Representative Name column now spans 2 columns -->
        <td colspan="1">
          {{ rep.repName }} - {{ rep.rep_taluka }}
        </td>

        <td style="text-align:right;">
          {{ rep.post }}
        </td>

        <td style="text-align:right;">
          {{ rep.haste }}
        </td>

        <td style="text-align:right;">
          {{ rep.magazine }}
        </td>

        <td style="text-align:right;">
          {{ rep.digital }}
        </td>

        <td style="border-right:2px solid black; text-align:right;">
          {{ rep.total }}
        </td>

      </tr>


      <!-- 🔹 DISTRICT TOTAL -->
      <tr class="fontBold">

        <td colspan="3"
            style="border-left:2px solid black; border-top:2px solid black; border-bottom:2px solid black; text-align:center; font-weight:bold;">
          {{ district.rep_district }} - एकूण
        </td>

        <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right; font-weight: bold;">
          {{ district.districtPost }}
        </td>

        <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right; font-weight: bold;">
          {{ district.districtHaste }}
        </td>

        <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right; font-weight: bold;">
          {{ district.districtMagazine }}
        </td>

        <td style="border-top:2px solid black; border-bottom:2px solid black; text-align:right; font-weight: bold;">
          {{ district.districtDigital }}
        </td>

        <td style="border-right:2px solid black; border-top:2px solid black; border-bottom:2px solid black; text-align:right; font-weight: bold;">
          {{ district.districtTotal }}
        </td>

      </tr>

    </ng-container>

  </ng-container>


  <!-- ================= GRAND TOTAL ================= -->
  <tr class="fontBold br_tp_bt">

    <td colspan="3"
        style="border-left:2px solid black; text-align:center;">
      एकूण
    </td>

    <td style="text-align:right;">
      {{ totalPostTotal }}
    </td>

    <td style="text-align:right;">
      {{ totalHasteTotal }}
    </td>

    <td style="text-align:right;">
      {{ totalMagzineTotal }}
    </td>

    <td style="text-align:right;">
      {{ totalDigitalTotal }}
    </td>

    <td style="border-right:2px solid black; text-align:right;">
      {{ grandTotal }}
    </td>

  </tr>

</tbody>


    </table>
  </div>

</ng-container>


<!-- LOADER -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>
